
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/short/[seasonId]/[episodeId]",
      function () {
        return require("private-next-pages/short/[seasonId]/[episodeId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/short/[seasonId]/[episodeId]"])
      });
    }
  